import { Flex, Spin } from '@brokerbay/elements-web';
import { Modal, Page } from 'components';
import { OnboardingWelcomeModalContext } from 'contexts';
import React, { useContext, useEffect } from 'react';
import { useHistory } from 'react-router';
import styled, { css } from 'styled-components';
import AppointmentBookingInternalContext from './AppointmentBookingInternalContext';
import AppointmentBookingInternalTabs from './AppointmentBookingInternalTabs';
import Header from './Header';
import InaccessibleListingPageWrapper from './InaccesibleListingPageWrapper';
import NoShowingsWrapper from './NoShowingsWrapper';
import {
  UNVERIFIED_ADMIN_MODAL,
  UNVERIFIED_AGENT_MODAL,
} from '../../../app/constants';

const AppointmentBookingInternalLayout: React.FC = () => {
  const history = useHistory();
  const { isDoneWelcomeFlow } = React.useContext(OnboardingWelcomeModalContext);
  const { isLoading, unverifiedModalState, setUnverifiedModalState } =
    useContext(AppointmentBookingInternalContext);

  useEffect(() => {
    if (!unverifiedModalState.shouldDisplay) return;
    // Only display after welcome modals are closed
    if (!isDoneWelcomeFlow) return;

    Modal.warning({
      ...(unverifiedModalState.isAgent
        ? UNVERIFIED_AGENT_MODAL
        : UNVERIFIED_ADMIN_MODAL),

      onOk: () => {
        if (unverifiedModalState.redirect) {
          // In case we were redirected from some other logic
          if (!history.location.hash.includes(unverifiedModalState.redirect)) {
            history.replace(unverifiedModalState.redirect);
            window.location.href = unverifiedModalState.redirect;
          }
        } else {
          setUnverifiedModalState(prev => ({ ...prev, shouldDisplay: false }));
        }
      },
    });
  }, [
    unverifiedModalState.shouldDisplay,
    isDoneWelcomeFlow,
    unverifiedModalState.isAgent,
    unverifiedModalState.redirect,
    history,
    setUnverifiedModalState,
  ]);

  if (isLoading) {
    return (
      <StyledFlex justify="center" align="center">
        <Spin size="large" dataCy="appointmentBooking-spinner" />
      </StyledFlex>
    );
  }

  if (unverifiedModalState.shouldDisplay) return null;

  return (
    <InaccessibleListingPageWrapper>
      <Page
        headerExtra={<Header />}
        headerDirection="column"
        headerVerticalAlign="baseline"
        type="filled"
        bodyCss={PageBodyCss}
        fillScreenHeight
      >
        <NoShowingsWrapper>
          <AppointmentBookingInternalTabs />
        </NoShowingsWrapper>
      </Page>
    </InaccessibleListingPageWrapper>
  );
};

const StyledFlex = styled(Flex)`
  min-height: inherit;
`;

const PageBodyCss = css`
  padding: 0 25px;
`;

export default AppointmentBookingInternalLayout;
